import { render, staticRenderFns } from "./BalanceAnalysis.vue?vue&type=template&id=5bcaaa0f&scoped=true&"
import script from "./BalanceAnalysis.vue?vue&type=script&lang=js&"
export * from "./BalanceAnalysis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bcaaa0f",
  null
  
)

export default component.exports